import axios from 'axios';

export const verifyUser = async (code) => {
    const response = await axios.get("/api/v1/verify/" + code);
    return response.data;
};